import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

const DropImageUploader = ({ name, onUpload, preview }) => {
  const [imagePreview, setImagePreview] = useState(preview || null);

  useEffect(() => {
    // Sync preview from parent if no uploaded image
    if (preview && !imagePreview) {
      setImagePreview(preview);
    }
  }, [preview, imagePreview]);

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);

      if (onUpload) {
        onUpload(file);
      }
    }
  }, [onUpload]);

  const maxSize = 2 * 1024 * 1024;

  const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
    onDrop,
    accept: { 'image/*': [] },
    multiple: false,
    maxSize,
  });

  return (
    <div className="uploader-container">
      <div
        {...getRootProps()}
        className={`dropzone ${isDragActive ? 'active' : ''}`}
      >
        <input {...getInputProps({ name: name })} />
        <p className='note'>{isDragActive ? 'Drop the image here...' : 'Drag & drop or click to upload an image'}</p>
      </div>

      {fileRejections.length > 0 && (
        <div className="error">
          <p>
            File size must be less than 2MB
          </p>
        </div>
      )}

      {imagePreview && (
        <div className="preview-container">
          {/* <p>Preview:</p> */}
          <img src={imagePreview} alt="Preview" className="preview-image" />
        </div>
      )}
    </div>
  );
};

export default DropImageUploader;
